import { subscribe } from '../appEventBus';
import { checkNetworkRequests } from '../../analytics/networkRequestDetection';

subscribe('AUTH_STATE_CHANGED', ({ user_id }) => {
  if (!user_id) return;

  checkNetworkRequests().catch((error: Error) => {
    console.error('checkNetworkRequests failed:', error.message);
  });
});
